import React, { useEffect, useState } from 'react';
import { Badge, Carousel, Image } from 'react-bootstrap';
import AlertIcon from 'mdi-react/AlertIcon';
import { useFormikContext } from 'formik';
import { get, isEqual } from 'lodash';

import { DocumentPicture } from 'entities/Document/interfaces';
import { useImageOnLoad } from 'modules/shared/hooks';
import styles from './CardImage.module.scss';

type Props = {
  type: 'driver' | 'forwarder' | 'vehicle' | 'trailer';
  isBlackList?: boolean;
};

const CardImage: React.FC<Props> = ({ type, isBlackList = false }) => {
  const [error, setError] = useState('');
  const { values } = useFormikContext();
  const [pictures, setPictures] = useState<DocumentPicture[]>([]);

  const { handleImageOnLoad, css } = useImageOnLoad();
  const field = get(values, type);

  useEffect(() => {
    if (isEqual(type, 'trailer') || isEqual(type, 'vehicle')) {
      const doc = get(field, 'document.pictures', []);
      setPictures([...doc]);
    } else {
      const doc = get(field, 'documents', []);
      const doc1 = get(doc[0], 'pictures', []);
      const doc2 = get(doc[1], 'pictures', []);

      setPictures([...doc1, ...doc2]);
    }
  }, [values]);

  useEffect(() => {
    if (!pictures.length) {
      setError('ФОТО ВІДСУТНЄ');
    } else {
      setError('');
    }
  }, [pictures]);

  return (
    <React.Fragment>
      {isBlackList ? (
        <Badge variant="dark" className={styles.badge_document}>
          <AlertIcon size={28} /> Належить до чорного списку!
        </Badge>
      ) : null}
      {!error && pictures && pictures.length > 0 && (
        <Carousel interval={null}>
          {pictures?.map((item, index) => (
            <Carousel.Item key={index} className="fade-in border-0 w-100">
              <Image
                className={styles.img_document}
                src={item.picture}
                alt="Фото недоступне"
                onLoad={handleImageOnLoad}
                style={{ ...css.fullSize }}
                rounded
              />
              <Badge variant="secondary" className={styles.badge_document}>
                {item.documentNumber}
              </Badge>
            </Carousel.Item>
          ))}
        </Carousel>
      )}
      {error && (
        <div className="d-flex align-items-center w-100 justify-content-center">
          <h3 className="text-danger text-center">{error}</h3>
        </div>
      )}
    </React.Fragment>
  );
};

export default CardImage;
